import { render, staticRenderFns } from "./Shou.vue?vue&type=template&id=5ac809bb&"
import script from "./Shou.vue?vue&type=script&scoped=true&lang=js&"
export * from "./Shou.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./Shou.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports